import { render, staticRenderFns } from "./launchpad.vue?vue&type=template&id=5388eb38&"
import script from "./launchpad.vue?vue&type=script&lang=js&"
export * from "./launchpad.vue?vue&type=script&lang=js&"
import style0 from "./launchpad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports